import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ show, handleClose, handleConfirm }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirmer l'action</Modal.Title>
            </Modal.Header>
            <Modal.Body>Etes-vous sûr de vouloir continuer?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Confirmer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;